export const EXTERNAL_TOOL_IDS = {
  VIPPS: "e391158a-9ba3-478a-a83d-c8c5a3ca86c9",
  NORWEGIAN_REWARD: "9f716345-d78c-468a-a8ba-bb07528f6813",
} as const;
